<template>
  <Card :bordered="false" class="response-message">
    <Icon type="md-checkmark-circle" size="120" color="#19be6b" class="message-icon" />
    <h2>Password Reset Successful</h2><br>
    <h4>You can now sign in with your new password.</h4>
  </Card>
</template>
<script>

  export default {
    name: "PasswordResetSuccess",
    data() {
      return {
      };
    },
  };
</script>
<style scoped>
</style>
